"use client";
import React from "react";
import { AspectRatio } from "~/components/ui/aspect-ratio";
import Image from "next/image";
import { Button } from "~/components/ui/button";
import { ArrowLongRight } from "~/components/icons";
import { LinkTrackers } from "~/components/reusables/link-trackers";
import { usePathname } from "next/navigation";
import StrapiBlocksRenderer from "~/components/reusables/strapi-blocks-renderer";

export function BannerClient({ banner, btn, blogs }) {
  const pathname = usePathname();
  // const showBanner = pathname == "/"  || pathname == "/the-internet-of-agents";
  const isHomepage = pathname == "/";
  const isIOAPage = pathname == "/the-internet-of-agents";
  const isQuantumShowcase = pathname == "/blog/showcase/quantum-computing";
  const iconURL = banner.ui[0].icon.data.attributes.url;
  const icon = banner.ui[0].icon.data.attributes;
  return (
    <>
      {/* Temporariliy hide dynmaic banner, using LF banner on both homepage and IOA page */}
      {isHomepage && (
        <div className="bg-gradient-to-r from-[#ECE80E] to-[#05BAD1] text-black ">
          <LinkTrackers
            segmentMsg="Banner Link Clicked"
            segmentOpt={{
              link_label: "Register today",
              location: "banner",
              resource_interaction: "visit the event registration page",
            }}
            href={btn.url}
            target="_blank"
            aria-label="Learn more about IOA"
            className="lg:font-btn group flex w-full items-center gap-1 py-5  text-xs md:py-6"
          >
            <div className="container flex min-h-14 items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="self-start lg:self-center">
                  {icon ? (
                    <div className="mt-1 h-full w-20 md:mr-6 md:w-24 lg:mt-0 lg:w-[120px]">
                      <AspectRatio ratio={icon.width / icon.height}>
                        <Image
                          src={iconURL}
                          alt="logo"
                          width={icon.width}
                          height={icon.height}
                          unoptimized
                        ></Image>
                      </AspectRatio>
                    </div>
                  ) : (
                    <div className="mt-1 h-full w-20 md:mr-6 md:w-24 lg:mt-0 lg:w-[120px]">
                      <AspectRatio ratio={179 / 74}>
                        <Image
                          src={
                            "https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/_logo-Outshift_1C-WHITE%402x%202.png"
                          }
                          alt="Outshift logo"
                          fill
                          unoptimized
                        ></Image>
                      </AspectRatio>
                    </div>
                  )}
                </div>
                {banner.description && (
                  <StrapiBlocksRenderer content={banner.description} />
                )}
              </div>

              <Button
                variant="secondary"
                className="align-end hidden min-w-32 px-0 font-medium text-black group-hover:bg-white group-hover:text-slate-900 md:px-3 lg:flex"
              >
                {btn.cta ? (
                  <p className="font-h6">{btn.cta}</p>
                ) : (
                  <div className="ml-1">
                    <ArrowLongRight size={35} />
                  </div>
                )}
              </Button>
              <div className="ml-1 lg:hidden">
                <ArrowLongRight size={35} />
              </div>
            </div>
          </LinkTrackers>
        </div>
      )}
      
      {isIOAPage && (
        <div className="bg-gradient-to-r from-[#00142B] to-[#FBAB2C] text-white ">
          <LinkTrackers
            segmentMsg="Banner Link Clicked"
            segmentOpt={{
              link_label: "Register today",
              location: "banner",
              resource_interaction: "visit the internet of agents event page",
            }}
            href="https://outshift.cisco.com/blog/agntcy-donated-to-linux-foundation"
            target="_blank"
            aria-label="Learn more about IOA"
            className="lg:font-btn group flex w-full items-center gap-1 py-5  text-xs md:py-6"
          >
            <div className="container mx-auto flex min-h-14 items-center justify-between gap-3">
              <div className="flex items-center gap-1 md:gap-3 lg:gap-6">
                <div className="flex flex-col items-center gap-2 self-start pr-3 md:flex-row lg:self-center lg:pr-0">
                  <div className="mt-1 h-full w-20 md:mr-6 md:w-24 lg:mt-0 lg:w-[120px]">
                    <AspectRatio ratio={113 / 26}>
                      <Image
                        src={"/images/logos/agntcy-logo.png"}
                        alt="agntcy logo"
                        fill
                        unoptimized
                      ></Image>
                    </AspectRatio>
                  </div>
                  <div className="mt-1 h-full w-20 md:mr-6 md:w-24 lg:mt-0 lg:w-[120px]">
                    <AspectRatio ratio={97 / 32}>
                      <Image
                        src={"/images/logos/lf-logo.png"}
                        alt="Linux Foundation logo"
                        fill
                        unoptimized
                      ></Image>
                    </AspectRatio>
                  </div>
                </div>
                <p className="md:font-p text-[14px] font-thin">
                  Breaking: AGNTCY becomes a Linux Foundation project with
                  enterprise backing
                </p>
                <div className="ml-1 group-hover:animate-bounce-x">
                  <ArrowLongRight size={35} />
                </div>
              </div>
            </div>
          </LinkTrackers>
        </div>
      )}

      {isQuantumShowcase && (
        <div className="bg-[#251238] text-white ">
          <LinkTrackers
            segmentMsg="Banner Link Clicked"
            segmentOpt={{
              link_label: "Try for free!",
              location: "banner",
              resource_interaction: "visit the internet of agents event page",
            }}
            href="/quantum-random-number-generator"
            target="_self"
            aria-label="Learn more about QRNG"
            className="lg:font-btn group flex w-full items-center gap-1 py-5  text-xs md:py-6"
          >
            <div className="container mx-auto flex min-h-14 items-center justify-between gap-3">
              <div className="flex items-center gap-3 lg:gap-6">
                <div className="flex flex-col items-center gap-2 self-start pr-3 md:flex-row lg:self-center lg:pr-0">
                  <div className="mt-1 h-full w-16 md:hidden">
                    <AspectRatio ratio={87 / 46}>
                      <Image
                        src="/images/logos/quantum/cisco-logo.png"
                        alt="cisco logo"
                        fill
                        unoptimized
                      ></Image>
                    </AspectRatio>
                  </div>
                  <div className="mt-1 h-full w-20 md:hidden">
                    <AspectRatio ratio={175 / 23}>
                      <Image
                        src={"/images/logos/quantum/quantum-labs-logo.png"}
                        alt="quantum labs logo"
                        fill
                        unoptimized
                      ></Image>
                    </AspectRatio>
                  </div>
                  <div className="mt-1 h-full max-md:hidden md:w-40 lg:mt-0 lg:w-52 xl:w-64">
                    <AspectRatio ratio={280 / 46}>
                      <Image
                        src={"/images/logos/quantum/cisco-Qlabs-logo1c.png"}
                        alt="quantum logo"
                        fill
                        unoptimized
                      ></Image>
                    </AspectRatio>
                  </div>
                </div>
                <p className="md:font-p text-[14px] font-thin">
                  Experience quantum in action with Outshift's Quantum Random
                  Number Generator via API
                </p>
              </div>
              <Button
                variant="secondary"
                className="align-end hidden min-w-32 rounded-lg bg-gradient-to-r from-[#1ABBB8] to-[#65BF5E] px-0 font-medium text-[#251238] transition duration-700 ease-in-out group-hover:bg-white group-hover:from-[#18CEE5] group-hover:to-[#ACE255] md:px-3 lg:flex"
              >
                <p className="font-h6">Try for free!</p>
              </Button>
              <div className="ml-1 lg:hidden">
                <ArrowLongRight size={35} />
              </div>
            </div>
          </LinkTrackers>
        </div>
      )}
    </>
  );
}
